import { render, staticRenderFns } from "./claimSettlementDetailList.vue?vue&type=template&id=91a80578&scoped=true"
import script from "./claimSettlementDetailList.vue?vue&type=script&lang=js"
export * from "./claimSettlementDetailList.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/qualityStyle.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./claimSettlementDetailList.vue?vue&type=style&index=1&id=91a80578&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a80578",
  null
  
)

export default component.exports